"use client";
import {
  FORGET_PASSWORD,
  LOGIN,
  LOGOUT,
  RESET_PASSWORD,
} from "@/lib/constants/api";
import { LoginUser } from "@/app/(auth)/register/types";
import API from "@/lib/constants/axios";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { JWTPayload } from "@/types/common.types";
import useUserStore from "@/store/user.store";
import useSettingStore from "@/store/settings.store";
import useLoaderStore from "@/store/loader.store";

export async function login(payload: LoginUser) {
  try {
    const res = await API.post(LOGIN, payload);

    if (res.status === 201) {
      const token = res.data.accessToken;
      const payload: JWTPayload = jwtDecode(token);
      Cookies.set("token", token);
      Cookies.set("sub", payload.sub);
      useUserStore.setState({ userId: payload.sub });
      return { success: true, user_name: res.data.user_name };
    }
    return { success: false };
  } catch (error) {
    return { success: false };
  }
}

export async function forgetPassword(payload: { email: string }) {
  try {
    const res = await API.post(FORGET_PASSWORD, payload);

    if (res.status === 201) {
      return {
        success: true,
        message:
          "Please check your email, We have sent you the reset password link.",
      };
    }
    return {
      success: false,
      message: "Something went wrong! please try again in sometime",
    };
  } catch (error) {
    return {
      success: false,
      message: "Something went wrong! please try again in sometime",
    };
  }
}
export async function resetPassword(
  params: string,
  payload: {
    newPassword: string;
  },
) {
  try {
    const res = await API.post(RESET_PASSWORD, payload, {
      params: {
        params,
      },
    });

    if (res.status === 201) {
      return {
        success: true,
        message: "Password has been reset successfully!",
      };
    }
    return {
      success: false,
      message: "Something went wrong! please try again in sometime",
    };
  } catch (error) {
    return {
      success: false,
      message: "Something went wrong! please try again in sometime",
    };
  }
}

export async function logout() {
  try {
    await API.post(LOGOUT);
  } catch (error) {
  } finally {
    useLoaderStore.getState().setLoading(false);
    Cookies.remove("token");
    Cookies.remove("sub");
    sessionStorage.removeItem("verificationPopupShown");
  }
}

export async function googleLogin(token: string) {
  const payload: JWTPayload = jwtDecode(token);
  Cookies.set("token", token);
  Cookies.set("sub", payload.sub);
  useUserStore.setState({ userId: payload.sub });
}
